import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_ARTICLE } from "../article.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateArticleInput } from "../../../__generated__/globalTypes";
import {
  UpdateArticleMutation,
  UpdateArticleMutationVariables,
} from "../../../__generated__/UpdateArticleMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateArticle = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateArticleInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateArticleMutation,
    UpdateArticleMutationVariables
  >(UPDATE_ARTICLE, {
    refetchQueries: ["ArticlesQuery", "ArticleQuery"],
    update(cache) {
      evictFields(cache, ["article", "articles"]);
    },
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateArticle?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateArticle?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
